import React, { Component } from 'react'
import { Link, NavLink } from 'react-router-dom'
import { connect } from 'react-redux';

class FooterBar extends Component {
  render() {
    const user = this.props.authentication.user;

    return (
      <footer class="page-footer font-small unique-color-dark pt-0">
        
        <div style={{ backgroundColor: '#6351ce'}}>
          <div class="container">
            <div class="row py-4 d-flex align-items-center">
              {/*
              <div class="col-md-6 col-lg-5 text-center text-md-left mb-4 mb-md-0">
                <h6 class="mb-0 text-white">Get connected with us on social networks!</h6>
              </div>

              <div class="col-md-6 col-lg-7 text-center text-md-right">
                <a class="fb-ic ml-0">
                  <i class="fa fa-facebook text-white mr-lg-4"> </i>
                </a>
                <a class="tw-ic">
                  <i class="fa fa-twitter text-white mr-lg-4"> </i>
                </a>
                <a class="gplus-ic">
                  <i class="fa fa-google-plus text-white mr-lg-4"> </i>
                </a>
                <a class="li-ic">
                  <i class="fa fa-linkedin text-white mr-lg-4"> </i>
                </a>
                <a class="ins-ic">
                  <i class="fa fa-instagram text-white mr-lg-4"> </i>
                </a>
              </div>
*/}
            </div>
          </div>
        </div>


        <div class="container mt-5 mb-4 text-center text-md-left">
          <div class="row mt-3">
            <div class="col-md-3 col-lg-4 col-xl-3 mb-4">
              <h6 class="text-uppercase font-weight-bold">
                <strong>Fix-a-Drink</strong>
              </h6>

              <hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
              <p>Find a great drink, fast with Fix-a-Drink!  Simply click on the ingredients you already have in your bar and fridge and we will tell you instantly what delicious drinks you can make.</p>

            </div>

            <div class="col-md-2 col-lg-2 col-xl-2 mx-auto mb-4">
              {/*<h6 class="text-uppercase font-weight-bold">
                <strong>Products</strong>
              </h6>
              <hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
              <p>
                <a href="#!">MDBootstrap</a>
              </p>
              <p>
                <a href="#!">MDWordPress</a>
              </p>
              <p>
                <a href="#!">BrandFlow</a>
              </p>
              <p>
                <a href="#!">Bootstrap Angular</a>
              </p>*/}
            </div>

            <div class="col-md-3 col-lg-2 col-xl-2 mx-auto mb-4">
              <h6 class="text-uppercase font-weight-bold">
                <strong>Useful links</strong>
              </h6>
              <hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>


                {user && user.first_name != "Guest" &&
                  <div>
                    <p>
                <Link to="/edit_profile">
                  Edit Profile
                </Link>
</p>
                <p>
                <Link to="/login">Logout</Link>
                  </p>
                  </div>
                }
                {user && user.first_name == "Guest" &&
                  <div>
                <p>
                <Link to="/register">
                  Create an Account
                </Link>
                </p>
                    <p>
                      <Link to="/login">
                        Login
                      </Link>
                    </p>
                    <p>
                      <Link to="/forgot_password">
                        Forgot Password
                      </Link>
                    </p>
                    </div>
                }
              {/*<p>
                <a href="#!">Become an Affiliate</a>
              </p>
              <p>
                <a href="#!">Help</a>
              </p>*/}
            </div>

            <div class="col-md-4 col-lg-3 col-xl-3">
              <h6 class="text-uppercase font-weight-bold">
                <strong>Contact</strong>
              </h6>
              <hr class="deep-purple accent-2 mb-4 mt-0 d-inline-block mx-auto" style={{width: '60px'}}/>
              {/*<p>
                <i class="fa fa-home mr-3"></i> New York, NY 10012, US</p>*/}
              <p>
                <i class="fa fa-envelope mr-3"></i> me@stevebreese.com</p>
              {/*<p>
                <i class="fa fa-phone mr-3"></i> + 01 234 567 88</p>
              <p>
                <i class="fa fa-print mr-3"></i> + 01 234 567 89</p>*/}
            </div>

          </div>
        </div>
        <div class="footer-copyright py-3 text-center">
          © {new Date().getFullYear()} Copyright:&nbsp;
          <a href="https://www.stevebreese.com">
            <strong>www.SteveBreese.com</strong>
          </a>
        </div>

      </footer>
    )
  }
}

function mapStateToProps(state) {
  const {authentication} = state;
  return {
    authentication
  };
}

const connectedFooterBar = connect(mapStateToProps, null, null, {pure:false})(FooterBar);
export { connectedFooterBar as FooterBar };


// WEBPACK FOOTER //
// ./src/FooterBar/FooterBar.jsx